module.exports = __webpack_public_path__ + "img/CS-UL-II_Overview-Rear_1.9d7c5366.jpg";